(function() {

  'use strict';



  /* Idempotency-Guard: Falls das Script versehentlich zweimal geladen wird

     (2x Script-Tag / Shopify-Doppelinclude), bricht die zweite Instanz still ab. */

  if (window.__vq_init_de) return;

  window.__vq_init_de = true;



  /* ── STATS → Google Sheet ── */

  var SHEET_URL = 'https://script.google.com/macros/s/AKfycbxCzo6XGex6ceLfENE_5zGTJvjy6NcMO25dV51Ae0HZNhsW0AVcLJloOxHL6QwLwmV8/exec';

  function sendToSheet(params) {

    if (!SHEET_URL) return;

    try {

      var qs = Object.keys(params).map(function(k) { return encodeURIComponent(k) + '=' + encodeURIComponent(params[k]); }).join('&');

      new Image().src = SHEET_URL + '?' + qs;

    } catch(e) {}

  }



  /* ── RABATTCODE nach Abschluss ── */

  var DISCOUNT_CODE = 'QUIZ10';

  var DISCOUNT_URL = '/discount/' + DISCOUNT_CODE + '?redirect=/cart';



  /* ── RESUME: Antworten in localStorage speichern, TTL 24h ── */

  var LS_KEY = 'viworo_quiz_de_v1';

  var LS_TTL_MS = 24 * 60 * 60 * 1000;

  function saveProgress() {

    try {

      localStorage.setItem(LS_KEY, JSON.stringify({ step: currentStep, answers: answers, ts: Date.now() }));

    } catch(e) {}

  }

  function loadProgress() {

    try {

      var raw = localStorage.getItem(LS_KEY);

      if (!raw) return null;

      var data = JSON.parse(raw);

      if (!data || typeof data.ts !== 'number' || Date.now() - data.ts > LS_TTL_MS) { localStorage.removeItem(LS_KEY); return null; }

      if (!Array.isArray(data.answers) || data.answers.length === 0) return null;

      if (typeof data.step !== 'number' || data.step < 0 || data.step >= QUESTIONS.length) return null;

      return data;

    } catch(e) { return null; }

  }

  function clearProgress() { try { localStorage.removeItem(LS_KEY); } catch(e) {} }



  /* ── German UI strings ── */

  var UI = {

    topBadge: 'Top-Empfehlung',

    scentLabel: 'Duftprofil:',

    tipLabel: '💡 Tipp:',

    ctaBtn: 'Jetzt entdecken',

    progressOf: 'von',

    whyPrefix: '',

    backBtn: '← Zurück'

  };



  /* ── OIL DATABASE (German only) ── */

  var OILS = {

    lavanda: {

      handle: 'lavendel-fein',

      latin: 'Lavandula angustifolia',

      name: 'Lavendel Fein (Bio)',

      scent: 'Krautig-floral, klar, rein',

      why: 'Der Klassiker für innere Ruhe. Sein sanfter, blumiger Duft wird in der Aromatherapie seit Generationen geschätzt, um den Abend einzuläuten und Entspannung zu finden.',

      tip: '1–2 Tropfen auf das Kopfkissen. Ideal auch zur Beruhigung irritierter Hautareale nach dem Sonnenbad.'

    },

    cembro: {

      handle: 'zirbelkiefer-oel-bio',

      latin: 'Pinus cembra',

      name: 'Zirbe (Bio)',

      scent: 'Alpin, holzig, harzig-warm',

      why: 'Ein Stück Alpen für dein Schlafzimmer. Der warme, holzige Duft der Zirbe wird traditionell mit tiefer Erholung und einem Gefühl von Geborgenheit verbunden.',

      tip: '30 Min. vor dem Schlafengehen im Diffuser aktivieren, um das Raumklima auf Tiefschlaf zu programmieren.'

    },

    ylang: {

      handle: 'bio-ylang-ylang',

      latin: 'Cananga odorata',

      name: 'Ylang-Ylang (Bio)',

      scent: 'Exotisch-süß, floral, schwer',

      why: 'Der sinnliche Exot. Sein üppiger, blumiger Duft wird in der Aromatherapie als natürlicher Stimmungsaufheller geschätzt – perfekt, um den Alltag hinter dir zu lassen.',

      tip: 'Sehr sparsam dosieren. In Kombination mit Bergamotte ein exzellenter Stimmungsaufheller.'

    },

    cedro: {

      handle: 'bio-zedernholz',

      latin: 'Cedrus atlantica',

      name: 'Atlas-Zeder (Bio)',

      scent: 'Holzig-herb, balsamisch, maskulin',

      why: 'Standfest wie der Baum selbst. Der tiefe, erdige Duft der Zeder schenkt Ruhe und Verwurzelung – ideal, wenn du innere Stabilität suchst.',

      tip: 'Exzellent für die Kopfhautpflege (2 Tropfen ins Shampoo mischen).'

    },

    rosmarino: {

      handle: 'bio-rosmarin',

      latin: 'Rosmarinus officinalis ct. cineol',

      name: 'Rosmarin (Bio)',

      scent: 'Frisch-krautig, kampferartig, belebend',

      why: 'Der natürliche Wachmacher. Sein kräftiger, kräuteriger Duft bringt frischen Wind in den Kopf – in der Aromatherapie traditionell für Fokus und Klarheit geschätzt.',

      tip: 'Perfekt für das Büro. Hocheffektiv mit Zitrone für konzentriertes Arbeiten.'

    },

    menta: {

      handle: 'bio-pfefferminze',

      latin: 'Mentha piperita',

      name: 'Pfefferminze (Bio)',

      scent: 'Kühl, klar, intensiv mentholhaltig',

      why: 'Die sofortige Erfrischung. Der kühlende Mentholduft weckt die Sinne und bringt angenehme Klarheit – wie eine frische Brise an einem heißen Tag.',

      tip: 'Für einen kühlenden Frischekick: 1 Tropfen verdünnt auf die Schläfen. Achtung: Nicht bei Säuglingen oder Kleinkindern anwenden.'

    },

    limone: {

      handle: 'bio-zitronen',

      latin: 'Citrus limon',

      name: 'Zitrone (Bio)',

      scent: 'Spritzig, frisch, klar',

      why: 'Wie ein Sonnenstrahl im Flakon. Der spritzige Zitrusduft hebt die Laune und bringt sofortige Frische in jeden Raum.',

      tip: 'Reinigt die Raumluft effektiv. Achtung: Phototoxisch – nach Hautkontakt 12h direkte Sonne vermeiden.'

    },

    lemongrass: {

      handle: 'bio-lemongrass',

      latin: 'Cymbopogon flexuosus',

      name: 'Lemongrass (Bio)',

      scent: 'Zitronig-herb, frisch, kraftvoll',

      why: 'Die exotische Frische. Der kräftige, zitronig-herbe Duft belebt Körper und Geist und wird traditionell auch zur Insektenabwehr und Raumluftreinigung geschätzt.',

      tip: 'In der Sportmassage (verdünnt) oder als natürlicher Frischekick im Auto-Diffuser.'

    },

    eucalipto: {

      handle: 'eukalyptus',

      latin: 'Eucalyptus globulus',

      name: 'Eukalyptus Globulus (Bio)',

      scent: 'Frisch, kampferartig, befreiend',

      why: 'Der Befreiende. Sein intensiv frischer Duft wird in der Aromatherapie als kraftvoller Begleiter für die kalte Jahreszeit geschätzt – sorgt für ein Gefühl von freiem Durchatmen.',

      tip: '3–5 Tropfen im Diffuser oder als Dampfinhalation in der kalten Jahreszeit. Für Kinder ab 6 Jahren – bei Jüngeren ist Cajeput die sanfte Alternative.'

    },

    teatree: {

      handle: 'bio-teebaum',

      latin: 'Melaleuca alternifolia',

      name: 'Teebaum (Bio)',

      scent: 'Würzig-herb, medizinisch, rein',

      why: 'Der Klassiker für die natürliche Hausapotheke. Sein würzig-frischer Duft steht für Reinheit und Pflege – ein vielseitiger Allrounder für den Alltag.',

      tip: 'Punktuell bei Unreinheiten auftragen. Ein Muss für jede natürliche Hausapotheke.'

    },

    ravintsara: {

      handle: 'bio-kampfer',

      latin: 'Cinnamomum camphora ct. cineol',

      name: 'Ravintsara (Bio)',

      scent: 'Frisch, mild, klärend',

      why: 'Die sanfte Kraft aus Madagaskar. Sein mild-frischer Duft wird in der Aromatherapie als besonders verträglicher Winterbegleiter geschätzt – ideal auch für empfindliche Anwender, die Eukalyptus zu intensiv finden.',

      tip: '3–4 Tropfen in 1 TL MCT-Öl mischen, abends sanft in die Fußsohlen einmassieren – das klassische Erkältungszeit-Ritual.'

    },

    cajeput: {

      handle: 'cajeput',

      latin: 'Melaleuca cajuputi',

      name: 'Cajeput (Bio)',

      scent: 'Frisch, leicht eukalyptusartig, mild-süß',

      why: 'Die sanfte Alternative zu Eukalyptus. Sein milder, frischer Duft wird in der Aromatherapie besonders für empfindsamere Anwender und Kinder ab 6 Jahren geschätzt.',

      tip: 'Hervorragend äußerlich anwendbar (nur um das Ohr herum einmassieren, stark verdünnt) oder als wohltuender Begleiter in der kalten Jahreszeit.'

    },

    pmugo: {

      handle: 'bio-latschenkiefer',

      latin: 'Pinus mugo',

      name: 'Latschenkiefer (Bio)',

      scent: 'Frisch-harzig, würzig, alpin',

      why: 'Die alpine Kraft für freies Durchatmen. Sein intensiver, harziger Duft erinnert an frische Bergluft und wird traditionell als wohltuender Saunabegleiter geschätzt.',

      tip: 'Der Klassiker für den Saunagang. 2–3 Tropfen im Aufgusswasser für ein befreiendes Erlebnis.'

    },

    bergamotto: {

      handle: 'bio-bergamotte',

      latin: 'Citrus bergamia',

      name: 'Bergamotte (Bio)',

      scent: 'Zitrusartig-floral, herb, edel',

      why: 'Das "Lichtbringer-Öl". Vereint die belebende Frische der Zitruswelt mit einer beruhigenden floralen Note – in der Aromatherapie geschätzt als natürlicher Stimmungsaufheller.',

      tip: 'Ideal bei trüber Winterstimmung. Achtung: Stark phototoxisch auf der Haut.'

    },

    arancio: {

      handle: 'bio-orangen-it',

      latin: 'Citrus sinensis',

      name: 'Süßorange (Bio)',

      scent: 'Warm-fruchtig, süß, sonnig',

      why: 'Wie Sonnenschein zum Einatmen. Sein warmer, fruchtiger Duft schafft eine Atmosphäre von Geborgenheit und Zuversicht – der Liebling der ganzen Familie.',

      tip: 'Das perfekte Einsteiger-Öl für den Diffuser im Wohnbereich, besonders beliebt bei Kindern.'

    },

    incenso: {

      handle: 'bio-weihrauch-boswellia-serrata-indien',

      latin: 'Boswellia carterii',

      name: 'Weihrauch (Bio)',

      scent: 'Warm-harzig, balsamisch, tiefgründig',

      why: 'Jahrtausendealte Tradition in einem Tropfen. Sein warmer, harziger Duft wird seit der Antike für Meditation und innere Einkehr geschätzt – ein Moment der Stille im Alltag.',

      tip: 'Für Meditation: 2 Tropfen im Diffuser. Für reife Haut: 1 Tropfen in deine Gesichtspflege (verdünnt).'

    },

    geranio: {

      handle: 'rosengeranie',

      latin: 'Pelargonium graveolens',

      name: 'Geranie (Bio)',

      scent: 'Floral-herb, rosig, balancierend',

      why: 'Die kleine Schwester der Rose. Ihr blumig-balancierender Duft wird in der Aromatherapie traditionell für emotionale Harmonie und innere Balance geschätzt.',

      tip: 'In Kombination mit Lavendel ein wunderbarer Begleiter für die Hautpflege.'

    },

    camomilla: {

      handle: 'kamillenol-romisch-bio',

      latin: 'Chamaemelum nobile',

      name: 'Römische Kamille (Bio)',

      scent: 'Warm-krautig, apfelartig, sanft',

      why: 'Sanftheit in Reinform. Ihr warmer, apfelartiger Duft wird in der Aromatherapie als eine der zartesten Möglichkeiten für tiefe Entspannung geschätzt.',

      tip: 'Ideal für Kinder (stark verdünnt) als beruhigendes Abendritual oder in aufregenden Zeiten.'

    },

    pepnero: {

      handle: 'pfeffer-schwarz-bio',

      latin: 'Piper nigrum',

      name: 'Schwarzer Pfeffer (Bio)',

      scent: 'Warm, würzig, trocken',

      why: 'Die wärmende Kraft der Gewürze. Sein würziger, anregender Duft wird in der Aromatherapie traditionell für wärmende Massagen und zur Vorbereitung auf sportliche Aktivität geschätzt.',

      tip: 'Zusammen mit einem Basisöl (z.B. MCT) für eine wärmende Sportmassage verwenden.'

    },

    palmarosa: {

      handle: 'bio-palmarosa-oel-nepal',

      latin: 'Cymbopogon martinii',

      name: 'Palmarosa (Bio)',

      scent: 'Rosig-süß, grasig, elegant',

      why: 'Die erschwingliche Alternative zur Rose. Sein rosiger, eleganter Duft wird in der Aromatherapie für einen strahlenden Teint und natürliche Hautpflege geschätzt.',

      tip: 'Ein Tropfen in die tägliche Feuchtigkeitscreme geben für einen strahlenden Teint (Glow-Effekt).'

    },

    patchouli: {

      handle: 'patchouli',

      latin: 'Pogostemon cablin',

      name: 'Patchouli',

      scent: 'Erdig, rauchig, exotisch',

      why: 'Tief erdend und sinnlich. Sein markanter, exotischer Duft bringt dich zurück auf den Boden – in der Aromatherapie geschätzt für innere Ruhe und Hautpflege.',

      tip: 'Wird mit dem Alter besser. Perfekt in Mischungen, um flüchtige Zitrusnoten zu fixieren.'

    },

    wintergruen: {

      handle: 'bio-wintergrunol',

      latin: 'Gaultheria procumbens',

      name: 'Wintergrün (Bio)',

      scent: 'Süß-medizinisch, intensiv, warm',

      why: 'Die intensive Kraft der Natur. Sein charakteristischer, süß-medizinischer Duft wird in der Aromatherapie traditionell für wärmende Massagen nach intensiven Bewegungsphasen geschätzt.',

      tip: 'Ideal verdünnt in einem Basisöl (max. 1 %) für eine gezielte Massage nach dem Sport. Schon wenige Tropfen reichen für ein wohltuendes Ergebnis.'

    },

    cipresso: {

      handle: 'bio-zypressen',

      latin: 'Cupressus sempervirens',

      name: 'Zypresse (Bio)',

      scent: 'Frisch-würzig, holzig, klar',

      why: 'Klarheit und Struktur aus der Mittelmeerregion. Sein frisch-würziger Duft wird in der Aromatherapie geschätzt, um Gedanken zu ordnen und Fokus zu finden.',

      tip: 'Perfekt für Meditationen, die einen Neuanfang oder klare Entscheidungen fokussieren.'

    },

    litsea: {

      handle: 'bio-litsea-cubeba-aetherisches-oel',

      latin: 'Litsea cubeba',

      name: 'Litsea Cubeba (Bio)',

      scent: 'Zitronig-intensiv, frisch, süßlich',

      why: 'Wird oft als "Öl der Engel" bezeichnet. Sein intensiv zitroniger Duft bringt Leichtigkeit und Klarheit – und ist dabei nicht phototoxisch wie Zitrusöle.',

      tip: 'Die sichere Alternative zur Zitrone für Hautanwendungen im Sommer.'

    },

    mandarino: {

      handle: 'bio-mandarinen',

      latin: 'Citrus reticulata',

      name: 'Rote Mandarine (Bio)',

      scent: 'Honigsüß, warm-fruchtig, sanft',

      why: 'Das sanfteste Zitrusöl. Sein honigsüßer, warmer Duft wird in der Aromatherapie besonders für abendliche Entspannung und als beruhigender Begleiter für Kinder geschätzt.',

      tip: 'Das ultimative "Trost-Öl" bei Überreizung. Sehr sicher in der Anwendung.'

    },

    citronella: {

      handle: 'citronella',

      latin: 'Cymbopogon nardus',

      name: 'Citronella (Bio)',

      scent: 'Frisch-zitronig, leicht grasig',

      why: 'Der natürliche Sommerschutz. Sein frischer, zitroniger Duft wird traditionell geschätzt, um laue Sommerabende ungestört im Freien zu genießen.',

      tip: 'Die Basis für jeden DIY-Insektenschutzspray. Auch hervorragend zur Desodorierung von Räumen geeignet.'

    },

    eucitriodora: {

      handle: 'zitroneneukalyptus-bio',

      latin: 'Corymbia citriodora',

      name: 'Zitroneneukalyptus (Bio)',

      scent: 'Zitronig-frisch, leicht rosig, hell',

      why: 'Die elegante Verbindung von Zitrusfrische und Eukalyptuskraft. Sein heller, zitroniger Duft wird traditionell als natürlicher Begleiter für den Sommer geschätzt.',

      tip: 'Die elegante Wahl für den Sommerabend – vertreibt lästige Gäste und wirkt gleichzeitig angenehm kühlend.'

    },

    lavhybrida: {

      handle: 'bio-lavendel',

      latin: 'Lavandula x hybrida',

      name: 'Lavandin (Bio)',

      scent: 'Kräftig-floral, frisch, kampferig',

      why: 'Die robustere Schwester des Lavendel fein. Durch den kräftigeren Charakter weniger schlaffördernd, dafür stärker erfrischend – perfekt für die Wäschepflege und große Räume.',

      tip: 'Perfekt für die Wäschepflege (2 Tropfen ins Weichspülerfach) oder zur Reinigung der Raumluft in größeren Räumen.'

    },

    garofano: {

      handle: 'bio-nelkenol',

      latin: 'Eugenia caryophyllus',

      name: 'Nelkenknospe (Bio)',

      scent: 'Würzig, scharf, warm',

      why: 'Ein Kraftpaket unter den Gewürzölen. Sein intensiver, würzig-warmer Duft wird in der Aromatherapie für seine starken reinigenden Eigenschaften geschätzt.',

      tip: 'Ein Tropfen in der Diffuser-Mischung reicht aus \u2013 kombiniert mit Orange und Zimt entsteht ein herrlich gem\u00fctlicher Winterduft.'

    },

    timo: {

      handle: 'bio-thymian',

      latin: 'Thymus vulgaris ct. thymol',

      name: 'Thymian (Bio)',

      scent: 'Stark krautig, würzig, medizinisch',

      why: 'Mediterrane Kräuterkraft. Sein intensiver, würziger Duft wird in der Aromatherapie als wärmender Winterbegleiter für Raumbeduftung und Saunaaufgüsse geschätzt.',

      tip: 'Im Diffuser: 2\u20133 Tropfen f\u00fcr kraftvoll-w\u00fcrzige Raumluft. Kombination mit Zitrone sorgt f\u00fcr frische Winterstimmung.'

    },

    zimtblatt: {

      handle: 'bio-zimtblatter',

      latin: 'Cinnamomum verum',

      name: 'Zimtblatt (Bio)',

      scent: 'Warm-würzig, zimtig, behaglich',

      why: 'Wie eine warme Umarmung. Sein behaglicher, würziger Duft erzeugt sofort Gemütlichkeit und wird in der Aromatherapie als wärmender Winterbegleiter geschätzt.',

      tip: 'Klassisches Winter-Öl für den Diffuser, ideal kombiniert mit Orange und Nelke für maximale Gemütlichkeit.'

    },

    pompelmo: {

      handle: 'grapefruit-bio',

      latin: 'Citrus paradisi',

      name: 'Grapefruit (Bio)',

      scent: 'Frisch, herb-bitter, belebend',

      why: 'Der belebende Frischekick. Sein herb-frischer Duft hebt die Stimmung und bringt Schwung in den Tag – in der Aromatherapie als natürlicher Motivator geschätzt.',

      tip: 'Ein idealer Begleiter zur Überwindung von Antriebslosigkeit am Morgen.'

    },

    salviamos: {

      handle: 'muskatellersalbei',

      latin: 'Salvia sclarea',

      name: 'Muskatellersalbei',

      scent: 'Nussig-krautig, warm, intensiv',

      why: 'Der Duft der inneren Balance. Sein warmer, nussig-kräuteriger Duft wird in der Aromatherapie traditionell für emotionale Ausgeglichenheit und tiefe Entspannung geschätzt.',

      tip: 'Ideal als Massageöl (verdünnt) für wohltuende Auszeiten. Nicht während der Schwangerschaft anwenden.'

    },

    petitgrain: {

      handle: 'petitgrain',

      latin: 'Citrus aurantium',

      name: 'Petitgrain (Bitterorangenblatt)',

      scent: 'Grün-frisch, herb-floral, edel',

      why: 'Die elegante Gelassenheit. Sein grün-frischer, herb-floraler Duft beruhigt, ohne müde zu machen – in der Aromatherapie geschätzt als Begleiter für stressige Arbeitsphasen.',

      tip: 'Ein exzellentes Öl für den Diffuser in stressigen Arbeitsphasen – es beruhigt, ohne schläfrig zu machen.'

    },

    fichte: {

      handle: 'fichtennadelol',

      latin: 'Picea abies',

      name: 'Fichte (Bio)',

      scent: 'Frisch, nadelig, kräftig',

      why: 'Frische Waldluft in Reinform. Sein kräftiger, nadeliger Duft stärkt die innere Widerstandskraft und vermittelt ein Gefühl von Naturverbundenheit.',

      tip: 'Hervorragend für stärkende Saunaufgüsse oder als belebender Badezusatz.'

    },

    laerche: {

      handle: 'larchen-bio',

      latin: 'Larix decidua',

      name: 'Lärche (Bio)',

      scent: 'Warm-holzig, balsamisch, sanft',

      why: 'Ein seltener Schatz aus den Alpen. Sein warmer, balsamischer Duft bietet emotionalen Halt und wird in der Aromatherapie für seine sanfte, tröstende Qualität geschätzt.',

      tip: 'Ein sehr verträgliches Nadelöl, ideal für Menschen, die Halt und Stabilität suchen.'

    },

    blutorange: {

      handle: 'bio-blutorange',

      latin: 'Citrus sinensis',

      name: 'Blutorange (Bio)',

      scent: 'Spritzig-süß, intensiv, sonnig',

      why: 'Sofortige Heiterkeit zum Einatmen. Sein intensiver, sonnig-süßer Duft bringt Licht in trübe Tage – die "Lichttherapie" der Aromatherapie.',

      tip: 'Unser Favorit für ein herzliches, warmes Raumklima im Familienbereich.'

    },

    limette: {

      handle: 'limette-bio',

      latin: 'Citrus aurantifolia',

      name: 'Limette (Bio)',

      scent: 'Herb-frisch, spritzig, animierend',

      why: 'Der spritzige Kreativbooster. Sein herb-frischer Duft klärt den Kopf und bringt frische Energie – in der Aromatherapie geschätzt für kreative Konzentration.',

      tip: 'Ideal für den Diffuser am Schreibtisch oder bei Müdigkeit am Vormittag.'

    },

    kuemmel: {

      handle: 'kummelol',

      latin: 'Carum carvi',

      name: 'Kümmel (Bio)',

      scent: 'Würzig, erdig, charakteristisch',

      why: 'Ein würziges, charakteristisches Öl aus der langen Kräutertradition. Sein erdiger Duft ist in der Aromatherapie ein bekannter Begleiter für Momente, in denen man sich Wärme und Ruhe gönnt.',

      tip: 'Sparsam in MCT-Öl verdünnt (1 %) für einen warmen, entspannenden Abend-Bauchwickel nach schweren Mahlzeiten.'

    },

    fenchel: {

      handle: 'bio-fenchelol',

      latin: 'Foeniculum vulgare',

      name: 'Fenchel (Bio)',

      scent: 'Süß, anisartig, warm',

      why: 'Sanft-süßer Klassiker der Mittelmeer-Küche. Sein weicher, anisartiger Duft ist in der Aromatherapie für seine beruhigende, harmonisierende Note bekannt.',

      tip: 'Verdünnt (max 1 %) in ein Trägeröl für eine sanfte, warme Abend-Einreibung am Oberbauch.'

    },

    anis: {

      handle: 'bio-sternanis',

      latin: 'Illicium verum',

      name: 'Sternanis (Bio)',

      scent: 'Süß, würzig, wärmend',

      why: 'Wärmendes Wohlgefühl für die kalte Jahreszeit. Sein süß-würziger Duft wird in der Aromatherapie traditionell für Entspannung und freies Durchatmen geschätzt.',

      tip: '2–3 Tropfen im Diffuser, kombiniert mit Orange und Zimt – ein klassischer Winterduft für den Wohnbereich.'

    },

    oregano: {

      handle: 'oregano',

      latin: 'Origanum vulgare',

      name: 'Oregano (Bio)',

      scent: 'Herb, würzig, intensiv',

      why: 'Einer der kraftvollsten Düfte der Natur. In der mediterranen Tradition seit Jahrhunderten für seine intensiven Eigenschaften geschätzt – ein echtes Kraftpaket.',

      tip: 'Im Diffuser sparsam: 1 Tropfen Oregano + 2 Tropfen Zitrone + 1 Tropfen Teebaum für eine kräftig-mediterrane Raumatmosphäre.'

    },

    salbei: {

      handle: 'salbei-1',

      latin: 'Salvia officinalis',

      name: 'Salbei (Bio)',

      scent: 'Krautig, klar, herb',

      why: 'Traditionell zur energetischen Reinigung geschätzt. Sein klarer, kräuteriger Duft bringt Frische in den Raum und Klarheit in den Geist.',

      tip: 'Ideal zur energetischen Raumreinigung: 2\u20133 Tropfen im Diffuser schaffen eine klare, frische Atmosph\u00e4re. Auch sch\u00f6n kombiniert mit Zitrone oder Lavendel.'

    }

  };



  /* ── IT-HANDLES (canonical Shopify handles for API fetches) ── */

  var IT_HANDLES = {

    'lavendel-fein': 'bio-lavanda-vera',

    'zirbelkiefer-oel-bio': 'olio-di-pino-cembro-bio',

    'bio-ylang-ylang': 'bio-ylang-ylang',

    'bio-zedernholz': 'bio-cedro',

    'bio-rosmarin': 'rosmarinus',

    'bio-pfefferminze': 'bio-menta-piperita',

    'bio-zitronen': 'bio-limone',

    'bio-lemongrass': 'bio-lemongrass',

    'eukalyptus': 'bio-eucalipto',

    'bio-teebaum': 'tea-tree-bio',

    'bio-kampfer': 'ravintsara',

    'cajeput': 'cajeput',

    'bio-latschenkiefer': 'bio-pino-mugo',

    'bio-bergamotte': 'bio-bergamotto',

    'bio-orangen-it': 'bio-arancio-dolce',

    'bio-weihrauch-boswellia-serrata-indien': 'incenso',

    'rosengeranie': 'geranio',

    'kamillenol-romisch-bio': 'camomilla-romana-bio',

    'pfeffer-schwarz-bio': 'olio-di-pepe-nero-bio',

    'bio-palmarosa-oel-nepal': 'olio-di-palmarosa-bio-nepal',

    'patchouli': 'patchouli',

    'bio-wintergrunol': 'olio-di-wintergreen-biologico',

    'bio-zypressen': 'cypress',

    'bio-litsea-cubeba-aetherisches-oel': 'bio-litsea-cubeba-olio-essenziale',

    'bio-mandarinen': 'bio-mandarino-rosso',

    'citronella': 'citronella',

    'zitroneneukalyptus-bio': 'olio-di-eucalipto-citriodora-biologico',

    'bio-lavanda': 'bio-lavanda',

    'bio-nelkenol': 'chiodi-di-garofano',

    'bio-thymian': 'olio-essenziale-di-timo-bio',

    'bio-zimtblatter': 'cannella',

    'grapefruit-bio': 'pompelmo-bio',

    'muskatellersalbei': 'salvia-moscatella',

    'petitgrain': 'petitgrain',

    'fichtennadelol': 'bio-abete-rosso',

    'larchen-bio': 'bio-larice',

    'bio-blutorange': 'bio-arancia-rossa',

    'limette-bio': 'bio-limetta',

    'kummelol': 'cumino-bio-dallungheria',

    'bio-fenchelol': 'olio-essenziale-di-finocchio-biologico',

    'bio-sternanis': 'anice-stellato',

    'oregano': 'oregano',

    'salbei-1': 'salvia'

  };



  function getItHandle(handle) {

    return IT_HANDLES[handle] || handle;

  }



  /* ── STATIC PRICE MAP (sofort sichtbar, kein Warten auf API) ──

     Werte manuell aus Shopify gepflegt, in Euro. Wenn die API einen anderen Preis liefert, überschreibt sie diesen Fallback. */



  /* ── QUESTIONS & SCORING ── */

  var QUESTIONS = [

    {

      title: 'Was ist dein wichtigstes Ziel?',

      subtitle: 'Wähle den Bereich, der für dich oberste Priorität hat.',

      options: [

        { icon: '🌲', label: 'Waldkraft & Freie Atemwege', desc: 'Tiefe Regeneration und freies Atmen wie im Hochgebirge.', scores: { fichte: 14, laerche: 13, cembro: 10, pmugo: 10, eucalipto: 16, ravintsara: 10, lavhybrida: 3, citronella: 2 } },

        { icon: '⚡', label: 'Energie & Stimmungs-Kick', desc: 'Sofortige Heiterkeit und mentale Wachheit.', scores: { blutorange: 15, limette: 12, limone: 10, pompelmo: 10, rosmarino: 10, litsea: 8, arancio: 7, lemongrass: 5 } },

        { icon: '😴', label: 'Tiefe Entspannung & Schlaf', desc: 'Den Kopf ausschalten und die Schlafqualität verbessern.', scores: { cembro: 15, lavanda: 12, incenso: 12, camomilla: 10, cedro: 8, ylang: 8, mandarino: 8, salviamos: 7, patchouli: 6, petitgrain: 5 } },

        { icon: '🧘', label: 'Bauchgefühl & Innere Mitte', desc: 'Wärme für den Bauchbereich und ein Gefühl innerer Erdung.', scores: { kuemmel: 15, fenchel: 12, anis: 10, menta: 13, salbei: 5 } },

        { icon: '🛡️', label: 'Schutz & Raumklima', desc: 'Natürliche Begleiter für die Erkältungszeit und frische Raumluft.', scores: { ravintsara: 15, teatree: 12, timo: 10, oregano: 10, garofano: 8, eucalipto: 12, cajeput: 7, citronella: 3, salbei: 5 } },

        { icon: '💪', label: 'Muskeln & Regeneration', desc: 'Lockerung nach dem Sport und Wärme für die Gelenke.', scores: { wintergruen: 15, pepnero: 12, rosmarino: 10, menta: 8, fichte: 5 } }

      ]

    },

    {

      title: 'Wie fühlst du dich aktuell?',

      subtitle: 'Wähle deinen emotionalen oder körperlichen Zustand.',

      options: [

        { icon: '😰', label: 'Gestresst & Angespannt', desc: 'Zu viele Gedanken, innere Unruhe.', scores: { lavanda: 10, bergamotto: 10, incenso: 8, cedro: 8, ylang: 7, blutorange: 7, cipresso: 6, salviamos: 5, petitgrain: 5, geranio: 3, palmarosa: 3 } },

        { icon: '😴', label: 'Müde & Antriebslos', desc: 'Brauche einen Fokus-Boost.', scores: { limone: 10, rosmarino: 10, menta: 14, limette: 8, pompelmo: 8, litsea: 7, lemongrass: 5 } },

        { icon: '🤒', label: 'Verschleimt & Angeschlagen', desc: 'Erste Anzeichen einer Erkältung.', scores: { fichte: 10, ravintsara: 10, eucalipto: 8, timo: 8, cajeput: 7, pmugo: 7, laerche: 7, lavhybrida: 3, eucitriodora: 3 } },

        { icon: '😟', label: 'Überwältigt & "Dünnhäutig"', desc: 'Suche Schutz und Geborgenheit.', scores: { laerche: 12, incenso: 18, cedro: 10, patchouli: 7, arancio: 6 } },

        { icon: '😣', label: 'Aufgebläht & Unwohl', desc: 'Druckgefühl im Bauchraum.', scores: { kuemmel: 12, fenchel: 10, anis: 8, camomilla: 5 } }

      ]

    },

    {

      title: 'Welche Duftrichtung bevorzugst du?',

      subtitle: 'Dies hilft uns, dein persönliches Lieblingsöl zu finden.',

      options: [

        { icon: '🌲', label: 'Waldig & Klar', desc: 'Wie ein Spaziergang im Nadelwald – frisch, harzig, belebend', scores: { fichte: 5, laerche: 5, cembro: 5, pmugo: 5, cipresso: 7, salbei: 3 } },

        { icon: '🍋', label: 'Zitrisch & Frisch', desc: 'Wie frisch gepresste Zitronen – spritzig, hell, belebend', scores: { limone: 5, blutorange: 5, limette: 5, pompelmo: 5, litsea: 5, arancio: 4, bergamotto: 4, eucitriodora: 3, lemongrass: 4, citronella: 3 } },

        { icon: '🌸', label: 'Blumig & Weich', desc: 'Wie ein Blumenstrauss – sanft, warm, beruhigend', scores: { lavanda: 5, geranio: 5, ylang: 5, palmarosa: 5, camomilla: 4, salviamos: 3, lavhybrida: 3, petitgrain: 3 } },

        { icon: '🪵', label: 'Würzig & Erdig', desc: 'Wie ein Kaminabend – warm, geheimnisvoll, erdend', scores: { cedro: 5, patchouli: 5, incenso: 5, pepnero: 4, kuemmel: 4, garofano: 3, zimtblatt: 3 } },

        { icon: '🎲', label: 'Überrasch mich!', desc: 'Duft ist mir egal – empfiehl mir das Beste für mein Ziel.', scores: {}, surprise: true }

      ]

    },

    {

      title: 'Gibt es etwas, das wir beachten sollen?',

      subtitle: 'So wählen wir die passendsten Öle für deinen Alltag.',

      options: [

        { icon: '✅', label: 'Für mich persönlich – keine Einschränkungen', desc: 'Zeige mir einfach deine besten Empfehlungen.', scores: {} },

        { icon: '🤰', label: 'Schwangerschaft / Stillzeit', desc: 'Wir empfehlen dir nur sanfte Öle.', scores: { salbei: -20, salviamos: -20, wintergruen: -20, timo: -20, garofano: -20, zimtblatt: -20, oregano: -20, menta: -10, rosmarino: -5 } },

        { icon: '👶', label: 'Kinder unter 6 Jahren im Haushalt', desc: 'Wir wählen besonders milde Öle für dich.', scores: { menta: -20, eucalipto: -20, timo: -20, oregano: -20, wintergruen: -20, garofano: -20, salbei: -20 } },

        { icon: '🧴', label: 'Sehr empfindliche Haut', desc: 'Wir meiden reizende Inhaltsstoffe.', scores: { timo: -10, oregano: -10, garofano: -10, zimtblatt: -10, menta: -5, limone: -2, lemongrass: -3 } }

      ]

    },
    {
      title: 'Wie möchtest du dein Öl anwenden?',
      subtitle: 'So bekommst du den passenden Tipp und die richtige Größe.',
      options: [
        { icon: '💨', label: 'Im Diffuser & für den Raum', desc: 'Duft im Wohnzimmer, Büro oder Schlafzimmer.', scores: { limone: 2, blutorange: 2, bergamotto: 2, lavanda: 2, eucalipto: 2, cembro: 2 } },
        { icon: '🤲', label: 'Auf der Haut & für Massagen', desc: 'Verdünnt mit einem Trägeröl.', scores: { lavanda: 3, geranio: 2, palmarosa: 2, camomilla: 2, incenso: 2, menta: -3, timo: -3, oregano: -3 } },
        { icon: '🔥', label: 'Für Sauna & Bad', desc: 'Aufguss und Badezusatz.', scores: { fichte: 3, pmugo: 3, laerche: 3, cembro: 3, eucalipto: 2, rosmarino: 2 } },
        { icon: '🤔', label: 'Weiß ich noch nicht', desc: 'Zeig mir einfach die beste Empfehlung.', scores: {} }
      ]
    }
  ];



  /* ── TRACKING (GA4 / GTM) ── */

  function trackEvent(name, params) {

    try {

      if (typeof gtag === 'function') gtag('event', name, params || {});

      if (window.dataLayer) { var e = { event: name }; if (params) { for (var k in params) { e[k] = params[k]; } } dataLayer.push(e); }

    } catch(err) {}

  }



  /* ── QUIZ ENGINE ── */

  var currentStep = -1;

  var answers = [];

  var totalQuestions = QUESTIONS.length;



  var quizEl = document.getElementById('viworo-quiz');

  var introEl = quizEl.querySelector('.vq-intro');

  var progressWrap = quizEl.querySelector('.vq-progress-wrap');

  var progressFill = quizEl.querySelector('.vq-progress-fill');

  var progressText = quizEl.querySelector('.vq-progress-text');

  var questionEl = quizEl.querySelector('.vq-question');

  var resultsEl = quizEl.querySelector('.vq-results');



  function showScreen(name) {
    /* V2: Ratgebertext und FAQ nur ausserhalb des Ergebnisses zeigen. */
    try { document.body.classList.toggle('vq-ergebnis', name === 'results'); } catch(e) {}

    [introEl, questionEl, resultsEl].forEach(function(s) {

      s.style.display = 'none';

      s.classList.remove('active');

    });

    progressWrap.style.display = (name === 'question') ? 'flex' : 'none';

    var target = name === 'intro' ? introEl : name === 'question' ? questionEl : resultsEl;

    target.style.display = 'block';

    requestAnimationFrame(function() {

      target.classList.add('active');

      /* Fokus auf die Titel-Überschrift setzen, damit Screen-Reader den neuen Inhalt ankündigen */

      var focusTarget = name === 'question' ? target.querySelector('.vq-q-title') :

                        name === 'results' ? target.querySelector('.vq-results-title') :

                        target.querySelector('.vq-title') || target;

      if (focusTarget) {

        focusTarget.setAttribute('tabindex', '-1');

        focusTarget.focus({ preventScroll: false });

      }

    });

  }



  function startQuiz() {

    trackEvent('quiz_start');

    sendToSheet({ t: 'start', lang: 'de' });

    currentStep = 0;

    answers = [];

    clearProgress();

    showScreen('question');

    renderQuestion(0);

  }



  function resumeQuiz(data) {

    trackEvent('quiz_resume', { quiz_step: data.step + 1 });

    currentStep = data.step;

    answers = data.answers.slice();

    showScreen('question');

    renderQuestion(currentStep);

  }



  function goBack() {

    if (currentStep > 0) {

      currentStep--;

      answers.pop();

      saveProgress();

      renderQuestion(currentStep);

    }

  }



  var isTransitioning = false;

  function selectOption(optIndex) {

    if (isTransitioning) return;

    isTransitioning = true;

    trackEvent('quiz_answer', { quiz_step: currentStep + 1, quiz_choice: QUESTIONS[currentStep].options[optIndex].label });

    var options = questionEl.querySelectorAll('.vq-option');

    for (var i = 0; i < options.length; i++) {

      options[i].setAttribute('aria-pressed', i === optIndex ? 'true' : 'false');

      options[i].classList.toggle('vq-selected', i === optIndex);

    }

    answers[currentStep] = optIndex;

    /* Kurze visuelle Bestätigung, dann weiter. Deutlich kürzer als vorher für bessere INP. */

    setTimeout(function() {

      currentStep++;

      isTransitioning = false;

      if (currentStep < totalQuestions) {

        saveProgress();

        renderQuestion(currentStep);

      } else {

        showResults();

      }

    }, 120);

  }



  function renderQuestion(idx) {

    var q = QUESTIONS[idx];

    var pct = ((idx + 1) / totalQuestions) * 100;

    progressFill.style.width = pct + '%';

    progressText.textContent = (idx + 1) + ' ' + UI.progressOf + ' ' + totalQuestions;

    quizEl.querySelector('.vq-progress-bar').setAttribute('aria-valuenow', Math.round(pct));

    questionEl.querySelector('.vq-q-title').textContent = q.title;

    questionEl.querySelector('.vq-q-subtitle').textContent = q.subtitle;

    var optWrap = questionEl.querySelector('.vq-options');

    optWrap.innerHTML = '';

    q.options.forEach(function(opt, i) {

      var card = document.createElement('button');

      card.type = 'button';

      card.className = 'vq-option';

      card.setAttribute('aria-pressed', 'false');

      card.innerHTML =

        '<span class="vq-option-icon" aria-hidden="true">' + opt.icon + '</span>' +

        '<span class="vq-option-text">' +

          '<span class="vq-option-label">' + opt.label + '</span>' +

          '<span class="vq-option-desc">' + opt.desc + '</span>' +

        '</span>';

      card.addEventListener('click', function() { selectOption(i); });

      optWrap.appendChild(card);

    });

    var backBtn = questionEl.querySelector('.vq-btn-back');

    backBtn.style.display = idx > 0 ? 'inline-block' : 'none';

    showScreen('question');

  }



  /* Hard-Stop: Öle die bei bestimmten Bedingungen KOMPLETT ausgeschlossen werden */

  var BLACKLIST = {

    /* Q4 Index 1 = Schwangerschaft */

    1: ['wintergruen', 'salviamos', 'salbei', 'timo', 'garofano', 'zimtblatt', 'oregano', 'menta', 'rosmarino', 'fenchel'],

    /* Q4 Index 2 = Kleinkinder */

    2: ['wintergruen', 'menta', 'eucalipto', 'timo', 'oregano', 'garofano', 'salbei']

  };



  /* Synergie-Bonus: Öl-Paare die sich gegenseitig verstärken */

  var SYNERGIES = [

    { oils: ['lavanda', 'cedro'], context: [2], bonus: 4 },           /* Schlaf → Lavendel+Zeder */

    { oils: ['lavanda', 'cembro'], context: [2], bonus: 4 },          /* Schlaf → Lavendel+Zirbe */

    { oils: ['eucalipto', 'ravintsara'], context: [0, 4], bonus: 4 }, /* Atemwege/Schutz → Euka+Ravintsara */

    { oils: ['bergamotto', 'arancio'], context: [1], bonus: 4 },      /* Stimmung → Bergamotte+Orange */

    { oils: ['pepnero', 'rosmarino'], context: [5], bonus: 4 },       /* Muskeln → Pfeffer+Rosmarin */

    { oils: ['menta', 'rosmarino'], context: [1], bonus: 2 },         /* Energie → Minze+Rosmarin */

    { oils: ['kuemmel', 'fenchel'], context: [3], bonus: 4 },         /* Bauchgefühl → Kümmel+Fenchel */

    { oils: ['fichte', 'laerche'], context: [0], bonus: 4 }           /* Waldkraft → Fichte+Lärche */

  ];



  function calculateScores() {

    var scores = {};

    var reasons = {}; /* welche Antwort hat wieviel zum Öl beigetragen */

    Object.keys(OILS).forEach(function(key) { scores[key] = 0; reasons[key] = []; });

    answers.forEach(function(optIdx, qIdx) {

      var opt = QUESTIONS[qIdx].options[optIdx];

      var weight = (qIdx === 0) ? 2 : 1;

      if (opt && opt.scores) {

        Object.keys(opt.scores).forEach(function(oilKey) {

          if (scores[oilKey] !== undefined && opt.scores[oilKey] > 0) {

            scores[oilKey] += opt.scores[oilKey] * weight;

            reasons[oilKey].push({ q: qIdx, label: opt.label, contribution: opt.scores[oilKey] * weight });

          } else if (scores[oilKey] !== undefined) {

            scores[oilKey] += opt.scores[oilKey] * weight;

          }

        });

      }

    });



    var q4 = answers[3];

    var banned = BLACKLIST[q4] || [];

    banned.forEach(function(key) { delete scores[key]; delete reasons[key]; });



    var q1 = answers[0];

    SYNERGIES.forEach(function(syn) {

      if (syn.context.indexOf(q1) === -1) return;

      var allPositive = syn.oils.every(function(o) { return scores[o] && scores[o] > 0; });

      if (allPositive) {

        syn.oils.forEach(function(o) { scores[o] += syn.bonus; });

      }

    });



    var positive = Object.keys(scores).filter(function(k) { return scores[k] > 0; });

    positive.sort(function(a, b) {

      var diff = scores[b] - scores[a];

      return diff !== 0 ? diff : (a < b ? -1 : 1);

    });

    var maxScore = positive.length > 0 ? scores[positive[0]] : 1;

    var results = [];

    for (var i = 0; i < positive.length && results.length < 3; i++) {

      var key = positive[i];

      /* Match-Prozent: relativ zum Top-Öl, mindestens 70% */

      var matchPct = Math.round((scores[key] / maxScore) * 100);

      /* Die beiden stärksten Beitragenden-Antworten für die "Weil du X und Y gewählt hast"-Erklärung */

      var topReasons = (reasons[key] || []).slice().sort(function(a, b) { return b.contribution - a.contribution; }).slice(0, 2);

      results.push({ key: key, score: scores[key], match: matchPct, reasons: topReasons });

    }

    if (results.length === 0) { results.push({ key: 'lavanda', score: 1, match: null, reasons: [] }); }

    return results;

  }



  function markUnavailable(btn) {

    if (!btn) return;

    btn.disabled = true;

    btn.style.background = '#9ca3af';

    btn.style.cursor = 'default';

    btn.innerHTML = 'Zurzeit nicht verfügbar';

    btn.setAttribute('aria-label', 'Zurzeit nicht verfügbar');

  }



  function getProductUrl(handle) {

    var root = quizEl.getAttribute('data-root-url') || '';

    if (root && root !== '/') {

      if (root.charAt(root.length - 1) !== '/') root += '/';

      return root + 'products/' + handle;

    }

    var path = window.location.pathname;

    var prefixes = ['/de-de/', '/de-at/', '/de-ch/', '/de/'];

    var base = '/de-de';

    for (var i = 0; i < prefixes.length; i++) {

      if (path.indexOf(prefixes[i]) === 0) {

        base = prefixes[i].slice(0, -1);

        break;

      }

    }

    return base + '/products/' + handle;

  }



  /* ════════════════════════════════════════════════════════════════
     QUIZ V2 (29.08.2026) — neuer Ergebnisbildschirm
     - eine klare Nr. 1 mit Produktbild, ein Hauptknopf
     - Daten (Titel/Preis/Bild/Varianten) aus dem MARKT, nicht aus dem Code
     - ausverkaufte Oele werden nie Nr. 1
     - "Ueberrasch mich" bekommt eine Entscheidung statt einer Auswahl
     - Groessenwahl, Set-Preis, Versandbalken, Sticky-Kaufleiste
     ════════════════════════════════════════════════════════════════ */

  var V2 = {"lang": "de", "q1": {"0": "du Waldkraft und freie Atemwege suchst", "1": "du Energie und gute Laune m\u00f6chtest", "2": "du besser schlafen willst", "3": "du innere Balance suchst", "4": "du einen Begleiter f\u00fcr die Erk\u00e4ltungszeit suchst", "5": "du nach dem Sport regenerieren willst"}, "q2": {"0": "gerade angespannt bist", "1": "gerade m\u00fcde bist", "2": "dich angeschlagen f\u00fchlst", "3": "gerade viel Schutz brauchst", "4": "dich aufgebl\u00e4ht f\u00fchlst"}, "q5": {"0": "F\u00fcr den Diffuser reichen 3\u20135 Tropfen.", "1": "Auf der Haut immer mit einem Tr\u00e4ger\u00f6l verd\u00fcnnen.", "2": "F\u00fcr den Aufguss lohnt sich die 30-ml-Flasche.", "3": ""}, "und": " und ", "weil": "Passt zu dir, weil ", "titel": "Dein \u00d6l: {oel}", "sub": "Aus \u00fcber 35 Bio-\u00d6len das, das am besten zu deinen Antworten passt.", "titelUeberrasch": "Wir haben f\u00fcr dich entschieden.", "subUeberrasch": "Du wolltest \u00fcberrascht werden \u2013 hier ist das eine \u00d6l, das zu dir passt.", "badge": "Top-Empfehlung", "badgeUeberrasch": "Deine \u00dcberraschung", "warumTitel": "Warum genau dieses \u00d6l", "punkt1": "Du hast {x} gew\u00e4hlt.", "punkt2": "Du f\u00fchlst dich {x}.", "cta": "In den Warenkorb", "ctaUeberrasch": "Ja, das probiere ich", "zurSeite": "Zur Produktseite", "proAnwendung": "Ab {p} \u20ac pro Anwendung \u00b7 ca. 250 Tropfen", "groesseLabel": "Gr\u00f6\u00dfe w\u00e4hlen", "auchPassend": "Auch passend", "altAufklappen": "Du willst doch vergleichen? Zwei Alternativen anzeigen", "setTitel": "Alle {n} zusammen", "setBtn": "Set in den Warenkorb", "dazuPasst": "Dazu passt", "hinzu": "Hinzuf\u00fcgen", "wirdHinzu": "Wird hinzugef\u00fcgt\u2026", "imKorb": "Im Warenkorb", "fehler": "Fehler \u2013 nochmal", "sicher": "Wir haben {n} \u00d6le f\u00fcr dich ausgeschlossen, die zu deiner Angabe nicht passen.", "versandSchwelle": 55, "versandNoch": "Noch {x} bis zum Gratisversand", "versandFrei": "\u2713 Gratisversand erreicht", "versandKurz": "Gratisversand ab 55 \u20ac", "codeText": "10 % auf deine Quiz-Bestellung \u00b7 einmal pro Kunde", "codeBtn": "Anwenden", "laedt": "Deine Empfehlung wird geladen\u2026", "leer": "Leider ist gerade keines der passenden \u00d6le lieferbar. Schau sp\u00e4ter nochmal vorbei.", "zubehoer": {"0": "ultraschalldiffusor", "1": "olio-mct-bio", "2": null, "3": null}, "zubehoerText": {"0": "3\u20135 Tropfen gen\u00fcgen f\u00fcr den ganzen Raum", "1": "Zum Verd\u00fcnnen f\u00fcr Haut und Massage", "2": "", "3": ""}, "tipp": {"0": "3\u20135 Tropfen in den Diffuser \u2013 f\u00fcr R\u00e4ume bis etwa 30 m\u00b2.", "1": "Mit einem Tr\u00e4ger\u00f6l verd\u00fcnnen: 2\u20133 Tropfen auf einen Teel\u00f6ffel MCT-\u00d6l.", "2": "F\u00fcr den Aufguss 5\u201310 Tropfen in einen Liter Wasser \u2013 nie unverd\u00fcnnt auf die Steine.", "3": null}};

  function fmtPreis(cent) {
    return (cent / 100).toFixed(2).replace('.', ',') + ' €';
  }

  /* Produktdaten vom AKTUELLEN Markt holen (richtige Sprache, richtiger Preis). */
  function ladeProdukt(handle) {
    var url = getProductUrl(handle) + '.js';
    return fetch(url)
      .then(function(r) { if (!r.ok) throw new Error('404'); return r.json(); })
      .then(function(p) {
        var varianten = (p.variants || []).filter(function(v) { return v.available; });
        return {
          ok: varianten.length > 0,
          handle: handle,
          titel: p.title || '',
          bild: p.featured_image || (p.images && p.images[0]) || null,
          varianten: varianten.map(function(v) {
            return { id: v.id, titel: v.title, preis: v.price };
          })
        };
      })
      .catch(function() { return { ok: false, handle: handle, titel: '', bild: null, varianten: [] }; });
  }

  /* Ein Satz, der ALLE Antworten aufgreift - nicht nur Frage 1 und 3. */
  function begruendung() {
    var teile = [];
    if (V2.q1[answers[0]]) teile.push(V2.q1[answers[0]]);
    if (V2.q2[answers[1]]) teile.push(V2.q2[answers[1]]);
    var satz = teile.length === 2 ? (teile[0] + V2.und + teile[1])
             : teile.length === 1 ? teile[0] : '';
    if (!satz) return '';
    var s = V2.weil + satz + '.';
    if (answers[4] !== undefined && V2.q5[answers[4]]) s += ' ' + V2.q5[answers[4]];
    return s;
  }

  /* Wurden Oele aus Sicherheitsgruenden ausgeschlossen? Das gehoert sichtbar gemacht. */
  function ausgeschlossen() {
    var b = BLACKLIST[answers[3]];
    return (b && b.length) ? b.length : 0;
  }

  /* Zubehoer passend zur Anwendung (Frage 5). */
  function zubehoerHandle() {
    if (answers[4] === undefined) return null;
    var z = V2.zubehoer[answers[4]];
    return z || null;
  }

  function showResults() {
    var results = calculateScores();
    var namen = results.map(function(r) { return OILS[r.key].name; });
    trackEvent('quiz_complete', { quiz_top1: namen[0] || '', quiz_top2: namen[1] || '', quiz_top3: namen[2] || '' });
    var sheetDaten = {
      t: 'done', lang: V2.lang,
      q1: answers[0] !== undefined ? QUESTIONS[0].options[answers[0]].label : '',
      q2: answers[1] !== undefined ? QUESTIONS[1].options[answers[1]].label : '',
      q3: answers[2] !== undefined ? QUESTIONS[2].options[answers[2]].label : '',
      q4: answers[3] !== undefined ? QUESTIONS[3].options[answers[3]].label : '',
      q5: (answers[4] !== undefined && QUESTIONS[4]) ? QUESTIONS[4].options[answers[4]].label : '',
      r1: namen[0] || '', r2: namen[1] || '', r3: namen[2] || ''
    };
    sendToSheet(sheetDaten);

    progressFill.style.width = '100%';
    quizEl.querySelector('.vq-progress-bar').setAttribute('aria-valuenow', 100);
    var cardsWrap = resultsEl.querySelector('.vq-results-cards');
    cardsWrap.innerHTML = '<div class="vq-laedt">' + V2.laedt + '</div>';
    var stale = resultsEl.querySelectorAll('.vq-urgency-banner, .vq-bundle-wrap, .vq-share-wrap, .vq-discount-box, .vq-v2-block, .vq-sticky');
    for (var s = 0; s < stale.length; s++) { stale[s].remove(); }
    showScreen('results');

    /* Erst alle Produktdaten holen, dann rendern - so steht nie ein falscher
       Preis auf dem Schirm und Ausverkauftes wird gar nicht erst Nr. 1. */
    var alle = results.map(function(r) { return ladeProdukt(OILS[r.key].handle); });
    var zh = zubehoerHandle();
    if (zh) alle.push(ladeProdukt(zh));

    Promise.all(alle).then(function(prods) {
      var zubehoer = zh ? prods.pop() : null;
      var paare = [];
      for (var i = 0; i < results.length; i++) {
        if (prods[i] && prods[i].ok) paare.push({ r: results[i], p: prods[i] });
      }
      if (paare.length === 0) {
        cardsWrap.innerHTML = '<div class="vq-leer">' + V2.leer + '</div>';
        return;
      }
      rendere(paare, zubehoer);
    });
  }

  function rendere(paare, zubehoer) {
    var cardsWrap = resultsEl.querySelector('.vq-results-cards');
    cardsWrap.innerHTML = '';
    var ueberrasch = QUESTIONS[2].options[answers[2]] && QUESTIONS[2].options[answers[2]].surprise === true;
    var top = paare[0];
    var rest = paare.slice(1);

    /* ── Kopfzeile: die gewaehlten Antworten als Chips ── */
    var personalEl = resultsEl.querySelector('.vq-results-personal');
    var chips = '';
    for (var qi = 0; qi < QUESTIONS.length; qi++) {
      if (answers[qi] === undefined) continue;
      var o = QUESTIONS[qi].options[answers[qi]];
      if (!o) continue;
      chips += '<span class="vq-chip">' + (o.icon || '') + ' ' + esc(o.label) + '</span>';
    }
    personalEl.innerHTML = '<div class="vq-chips">' + chips + '</div>' +
      '<h3 class="vq-erg-titel">' + (ueberrasch ? V2.titelUeberrasch : V2.titel.replace('{oel}', esc(top.p.titel))) + '</h3>' +
      '<p class="vq-erg-sub">' + (ueberrasch ? V2.subUeberrasch : V2.sub) + '</p>';

    /* ── Nr. 1 als Hauptkarte ── */
    var hero = document.createElement('div');
    hero.className = 'vq-hero';
    var oil = OILS[top.r.key];
    var vs = top.p.varianten;
    var gruende = begruendung();
    var n = ausgeschlossen();

    var h = '<div class="vq-hero-top">';
    if (top.p.bild) {
      h += '<img class="vq-hero-bild" src="' + top.p.bild + '&width=260" alt="' + esc(top.p.titel) + '" loading="eager" width="118" height="118">';
    }
    h += '<div class="vq-hero-kopf">';
    h += '<span class="vq-badge">' + (ueberrasch ? V2.badgeUeberrasch : V2.badge + (top.r.match ? ' · ' + top.r.match + '% Match' : '')) + '</span>';
    h += '<div class="vq-hero-name">' + esc(top.p.titel) + '</div>';
    h += '<div class="vq-hero-latein">' + esc(oil.latin) + '</div>';
    h += '</div></div>';

    if (ueberrasch) {
      h += '<div class="vq-warum-box"><b>' + V2.warumTitel + '</b><ul>';
      if (V2.q1[answers[0]]) h += '<li>' + V2.punkt1.replace('{x}', '<b>' + esc(QUESTIONS[0].options[answers[0]].label) + '</b>') + '</li>';
      if (V2.q2[answers[1]]) h += '<li>' + V2.punkt2.replace('{x}', '<b>' + esc(QUESTIONS[1].options[answers[1]].label) + '</b>') + '</li>';
      h += '<li>' + esc(oil.why) + '</li>';
      h += '</ul></div>';
    } else {
      if (gruende) h += '<div class="vq-warum">' + gruende + '</div>';
      h += '<p class="vq-hero-why">' + esc(oil.why) + '</p>';
    }
    h += '<div class="vq-hero-duft">🌬️ ' + UI.scentLabel + ' ' + esc(oil.scent) + '</div>';
    h += '<div class="vq-hero-tipp">' + UI.tipLabel + ' ' + esc(tippText(oil)) + '</div>';

    /* Groessenwahl - nur wenn es wirklich mehrere kaufbare Varianten gibt */
    if (vs.length > 1) {
      h += '<div class="vq-groessen" role="group" aria-label="' + V2.groesseLabel + '">';
      for (var i = 0; i < vs.length && i < 3; i++) {
        h += '<button type="button" class="vq-groesse' + (i === 0 ? ' vq-on' : '') + '" data-vid="' + vs[i].id +
             '" data-preis="' + vs[i].preis + '">' + esc(vs[i].titel) + '<small>' + fmtPreis(vs[i].preis) + '</small></button>';
      }
      h += '</div>';
    }
    h += '<button type="button" class="vq-haupt-cta vq-add-to-cart ajax-add-to-cart-btn" data-variant-id="' + vs[0].id + '">' +
         (ueberrasch ? V2.ctaUeberrasch : V2.cta) + ' <span class="vq-cta-preis">· ' + fmtPreis(vs[0].preis) + '</span></button>';
    h += '<a class="vq-hero-link" href="' + getProductUrl(top.p.handle) + '">' + V2.zurSeite + '</a>';
    h += '<div class="vq-hero-kosten">' + V2.proAnwendung.replace('{p}', (vs[0].preis / 100 / 250).toFixed(2).replace('.', ',')) + '</div>';
    if (n > 0) h += '<div class="vq-sicher">🛡️ ' + V2.sicher.replace('{n}', n) + '</div>';
    hero.innerHTML = h;
    cardsWrap.appendChild(hero);

    /* Groessenwahl verdrahten */
    var gBtns = hero.querySelectorAll('.vq-groesse');
    var cta = hero.querySelector('.vq-haupt-cta');
    for (var gi = 0; gi < gBtns.length; gi++) {
      gBtns[gi].addEventListener('click', function() {
        for (var k = 0; k < gBtns.length; k++) gBtns[k].classList.remove('vq-on');
        this.classList.add('vq-on');
        var vid = this.getAttribute('data-vid'), pr = parseInt(this.getAttribute('data-preis'), 10);
        cta.setAttribute('data-variant-id', vid);
        cta.querySelector('.vq-cta-preis').textContent = '· ' + fmtPreis(pr);
        hero.querySelector('.vq-hero-kosten').textContent = V2.proAnwendung.replace('{p}', (pr / 100 / 250).toFixed(2).replace('.', ','));
        aktualisiereSticky(top.p.titel, this.textContent, pr, vid);
      });
    }
    inKorb(cta, top.p.titel);
    hero.querySelector('.vq-hero-link').addEventListener('click', function() {
      trackEvent('quiz_product_click', { quiz_product: top.p.titel });
      sendToSheet({ t: 'click', lang: V2.lang, r1: top.p.titel });
    });

    /* ── Nr. 2 und 3 als kompakte Zeilen ── */
    if (rest.length) {
      var box = document.createElement('div');
      box.className = 'vq-v2-block';
      var rh = '<h4 class="vq-zwischen">' + (ueberrasch ? '' : V2.auchPassend) + '</h4>';
      if (ueberrasch) rh = '<details class="vq-alt"><summary>' + V2.altAufklappen + '</summary>';
      for (var j = 0; j < rest.length; j++) {
        var rp = rest[j];
        rh += '<div class="vq-zeile" data-vid="' + rp.p.varianten[0].id + '" data-name="' + esc(rp.p.titel) + '">';
        if (rp.p.bild) rh += '<img src="' + rp.p.bild + '&width=120" alt="" loading="lazy" width="52" height="52">';
        rh += '<div class="vq-zeile-t"><div class="vq-zeile-n">' + esc(rp.p.titel) + '</div>' +
              '<div class="vq-zeile-m">' + (rp.r.match ? rp.r.match + '% Match · ' : '') + esc(rp.p.varianten[0].titel) + '</div></div>' +
              '<div class="vq-zeile-p">' + fmtPreis(rp.p.varianten[0].preis) + '</div>' +
              '<button type="button" class="vq-plus" aria-label="' + V2.hinzu + '">+</button></div>';
      }
      if (ueberrasch) rh += '</details>';
      box.innerHTML = rh;
      cardsWrap.parentNode.insertBefore(box, cardsWrap.nextSibling);
      verdrahteZeilen(box);

      /* Set-Knopf mit echtem Gesamtpreis */
      var summe = 0;
      for (var sj = 0; sj < paare.length; sj++) summe += paare[sj].p.varianten[0].preis;
      var setDiv = document.createElement('div');
      setDiv.className = 'vq-v2-block vq-set';
      setDiv.innerHTML = '<div class="vq-set-z"><span>' + V2.setTitel.replace('{n}', paare.length) + '</span><b>' + fmtPreis(summe) + '</b></div>' +
        '<button type="button" class="vq-set-btn">' + V2.setBtn + '</button>';
      box.parentNode.insertBefore(setDiv, box.nextSibling);
      setDiv.querySelector('.vq-set-btn').addEventListener('click', function() {
        var items = paare.map(function(x) { return { id: x.p.varianten[0].id, quantity: 1 }; });
        var b = this; b.disabled = true; b.textContent = V2.wirdHinzu;
        trackEvent('quiz_bundle_click');
        sendToSheet({ t: 'cart', lang: V2.lang, r1: 'SET (' + paare.length + ')' });
        fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) })
          .then(function() { window.location.href = DISCOUNT_URL; })
          .catch(function() { b.textContent = V2.fehler; b.disabled = false; });
      });
    }

    /* ── Zubehoer passend zur Anwendung ── */
    if (zubehoer && zubehoer.ok) {
      var zb = document.createElement('div');
      zb.className = 'vq-v2-block';
      zb.innerHTML = '<h4 class="vq-zwischen">' + V2.dazuPasst + '</h4>' +
        '<div class="vq-zeile" data-vid="' + zubehoer.varianten[0].id + '" data-name="' + esc(zubehoer.titel) + '">' +
        (zubehoer.bild ? '<img src="' + zubehoer.bild + '&width=120" alt="" loading="lazy" width="52" height="52">' : '') +
        '<div class="vq-zeile-t"><div class="vq-zeile-n">' + esc(zubehoer.titel) + '</div>' +
        '<div class="vq-zeile-m">' + esc(V2.zubehoerText[answers[4]] || '') + '</div></div>' +
        '<div class="vq-zeile-p">' + fmtPreis(zubehoer.varianten[0].preis) + '</div>' +
        '<button type="button" class="vq-plus" aria-label="' + V2.hinzu + '">+</button></div>';
      cardsWrap.parentNode.appendChild(zb);
      verdrahteZeilen(zb);
    }

    /* ── Versandbalken ── */
    fetch('/cart.js').then(function(r) { return r.json(); }).then(function(c) {
      var schwelle = V2.versandSchwelle * 100;
      var fehlt = Math.max(0, schwelle - c.total_price);
      var vb = document.createElement('div');
      vb.className = 'vq-v2-block vq-versand';
      vb.innerHTML = (fehlt > 0
        ? V2.versandNoch.replace('{x}', '<b>' + fmtPreis(fehlt) + '</b>')
        : V2.versandFrei) +
        '<div class="vq-bar"><i style="width:' + Math.min(100, Math.round(c.total_price / schwelle * 100)) + '%"></i></div>';
      cardsWrap.parentNode.appendChild(vb);
    }).catch(function() {});

    /* ── Rabattcode, kompakt ── */
    var db = document.createElement('div');
    db.className = 'vq-v2-block vq-code';
    db.innerHTML = '<div><span class="vq-code-c">' + DISCOUNT_CODE + '</span><small>' + V2.codeText + '</small></div>' +
      '<a class="vq-code-btn" href="' + DISCOUNT_URL + '">' + V2.codeBtn + '</a>';
    cardsWrap.parentNode.appendChild(db);
    db.querySelector('.vq-code-btn').addEventListener('click', function() {
      trackEvent('quiz_discount_apply', { quiz_code: DISCOUNT_CODE });
    });

    /* ── Sticky-Kaufleiste (70 % der Nutzer sind am Handy) ── */
    var sticky = document.createElement('div');
    sticky.className = 'vq-sticky';
    sticky.innerHTML = '<div class="vq-sticky-t"><div class="vq-sticky-n"></div><div class="vq-sticky-p"></div></div>' +
      '<button type="button" class="vq-sticky-btn">' + V2.cta + '</button>';
    quizEl.appendChild(sticky);
    aktualisiereSticky(top.p.titel, vs[0].titel, vs[0].preis, vs[0].id);
    sticky.querySelector('.vq-sticky-btn').addEventListener('click', function() {
      var b = hero.querySelector('.vq-haupt-cta');
      if (b) b.click();
    });
    var beobachter = new IntersectionObserver(function(eintraege) {
      sticky.classList.toggle('vq-sichtbar', !eintraege[0].isIntersecting);
    }, { threshold: 0 });
    beobachter.observe(hero.querySelector('.vq-haupt-cta'));

    clearProgress();
    surveyEl.style.display = 'none';
    surveySubmitted = false;
    setTimeout(function() { if (!surveySubmitted) surveyEl.style.display = 'block'; }, 8000);
  }

  function aktualisiereSticky(name, groesse, preis, vid) {
    var st = quizEl.querySelector('.vq-sticky');
    if (!st) return;
    st.querySelector('.vq-sticky-n').textContent = name + (groesse ? ' · ' + String(groesse).split('\n')[0] : '');
    st.querySelector('.vq-sticky-p').textContent = fmtPreis(preis) + ' · ' + V2.versandKurz;
    st.setAttribute('data-vid', vid);
  }

  function verdrahteZeilen(wurzel) {
    var zeilen = wurzel.querySelectorAll('.vq-zeile');
    for (var i = 0; i < zeilen.length; i++) {
      (function(z) {
        z.querySelector('.vq-plus').addEventListener('click', function() {
          var vid = parseInt(z.getAttribute('data-vid'), 10);
          var nm = z.getAttribute('data-name');
          var b = this;
          if (!vid) return;
          b.disabled = true; b.textContent = '…';
          fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: vid, quantity: 1 }] }) })
            .then(function() {
              b.textContent = '✓'; b.classList.add('vq-ok');
              trackEvent('quiz_add_to_cart', { quiz_product: nm });
              sendToSheet({ t: 'cart', lang: V2.lang, r1: nm });
              setTimeout(function() { b.textContent = '+'; b.classList.remove('vq-ok'); b.disabled = false; }, 2200);
            })
            .catch(function() { b.textContent = '!'; b.disabled = false; });
        });
      })(zeilen[i]);
    }
  }

  function inKorb(btn, name) {
    btn.addEventListener('click', function() {
      var vid = parseInt(btn.getAttribute('data-variant-id'), 10);
      if (!vid) return;
      var alt = btn.innerHTML;
      btn.disabled = true; btn.textContent = V2.wirdHinzu;
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: vid, quantity: 1 }] }) })
        .then(function() {
          btn.innerHTML = '✓ ' + V2.imKorb;
          btn.classList.add('vq-ok');
          trackEvent('quiz_add_to_cart', { quiz_product: name });
          sendToSheet({ t: 'cart', lang: V2.lang, r1: name });
          setTimeout(function() { btn.innerHTML = alt; btn.classList.remove('vq-ok'); btn.disabled = false; }, 2500);
        })
        .catch(function() { btn.textContent = V2.fehler; btn.disabled = false; });
    });
  }

  /* Tipp passend zur gewaehlten Anwendung (Frage 5), sonst der Standardtipp. */
  function tippText(oil) {
    if (answers[4] !== undefined && V2.tipp[answers[4]]) return V2.tipp[answers[4]];
    return oil.tip;
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function(c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  quizEl.querySelector('.vq-start-btn').addEventListener('click', startQuiz);

  quizEl.querySelector('.vq-btn-back').addEventListener('click', goBack);



  /* Resume-Hinweis im Intro, wenn Session < 24h alt */

  (function() {

    var saved = loadProgress();

    if (!saved) return;

    var startBtn = quizEl.querySelector('.vq-start-btn');

    var resumeBtn = document.createElement('button');

    resumeBtn.className = 'vq-btn vq-btn-primary';

    resumeBtn.style.cssText = 'background:#2d572c;margin-top:0.5rem;';

    resumeBtn.textContent = '↻ Dort weitermachen wo du aufgehört hast (Frage ' + (saved.step + 1) + ')';

    startBtn.parentNode.insertBefore(resumeBtn, startBtn.nextSibling);

    startBtn.textContent = 'Neu starten';

    startBtn.className = 'vq-btn vq-btn-back';

    resumeBtn.addEventListener('click', function() { resumeQuiz(saved); });

  })();



  var restartBtn = quizEl.querySelector('.vq-btn-restart');

  restartBtn.addEventListener('click', function() {

    currentStep = -1;

    answers = [];

    clearProgress();

    surveyEl.style.display = 'none';

    surveySubmitted = false;

    quizEl.querySelector('.vq-survey-thanks').style.display = 'none';

    showScreen('intro');

  });



  /* ── SURVEY ── */

  var surveyEl = quizEl.querySelector('.vq-survey');

  var quizStarsEl = quizEl.querySelector('#vq-stars-quiz');

  var oilsStarsEl = quizEl.querySelector('#vq-stars-oils');

  var quizStarButtons = quizStarsEl ? quizStarsEl.querySelectorAll('.vq-star') : [];

  var oilsStarButtons = oilsStarsEl ? oilsStarsEl.querySelectorAll('.vq-star') : [];

  var quizRating = 0;

  var oilsRating = 0;

  var surveySubmitted = false;



  function setupStarGroup(starButtons, setRating) {

    for (var si = 0; si < starButtons.length; si++) {

      (function(star) {

        star.addEventListener('click', function() {

          var val = parseInt(this.getAttribute('data-value'), 10);

          setRating(val);

          for (var j = 0; j < starButtons.length; j++) {

            starButtons[j].classList.toggle('vq-star-active', parseInt(starButtons[j].getAttribute('data-value'), 10) <= val);

          }

        });

        star.addEventListener('mouseenter', function() {

          var hv = parseInt(this.getAttribute('data-value'), 10);

          for (var j = 0; j < starButtons.length; j++) {

            starButtons[j].classList.toggle('vq-star-hover', parseInt(starButtons[j].getAttribute('data-value'), 10) <= hv);

          }

        });

        star.addEventListener('mouseleave', function() {

          for (var j = 0; j < starButtons.length; j++) { starButtons[j].classList.remove('vq-star-hover'); }

        });

      })(starButtons[si]);

    }

  }



  setupStarGroup(quizStarButtons, function(v) { quizRating = v; });

  setupStarGroup(oilsStarButtons, function(v) { oilsRating = v; });



  quizEl.querySelector('.vq-btn-survey-submit').addEventListener('click', function() {

    if (surveySubmitted) return;

    if (quizRating === 0 && oilsRating === 0) {

      /* Gentle hint instead of silent fail */

      var btn = this;

      btn.textContent = 'Bitte vergib mindestens 1 Stern ⭐';

      btn.style.background = '#f59e0b';

      setTimeout(function() { btn.textContent = 'Feedback absenden'; btn.style.background = ''; }, 2500);

      return;

    }

    var comment = quizEl.querySelector('#vq-survey-tips').value || '';

    var emailInput = quizEl.querySelector('#vq-survey-email');

    var email = emailInput ? (emailInput.value || '').trim() : '';

    /* Simple E-Mail-Validierung */

    if (email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {

      emailInput.style.borderColor = '#dc2626';

      emailInput.focus();

      return;

    }

    sendToSheet({

      t: 'feedback', lang: 'de',

      stars_quiz: quizRating, stars_oils: oilsRating,

      comment: comment.substring(0, 200),

      email: email.substring(0, 100)

    });

    trackEvent('quiz_feedback', { quiz_stars: quizRating, oils_stars: oilsRating, has_email: email ? 1 : 0 });

    surveySubmitted = true;

    surveyEl.style.display = 'none';

    quizEl.querySelector('.vq-survey-thanks').style.display = 'block';

  });



})();

